import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export const Badge = ({ children, variant = 'default' }) => {
  const variants = {
    disponible: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    reservado: 'bg-brand-light text-brand-primary border-brand-primary/30',
    ocupado: 'bg-brand-dark text-white border-brand-dark',
    mantenimiento: 'bg-brand-warning/20 text-brand-warning border-brand-warning/50',
    activo: 'bg-green-100 text-green-700 border-green-300',
    inactivo: 'bg-gray-200 text-gray-600 border-gray-300',
    potencial: 'bg-blue-100 text-blue-700 border-blue-300',
    confirmada: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    pendiente: 'bg-yellow-100 text-yellow-700 border-yellow-300',
    pagado: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    abierta: 'bg-brand-alert/20 text-brand-alert border-brand-alert/50',
    resuelta: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    finalizada: 'bg-gray-200 text-gray-700 border-gray-300',
    bloqueado: 'bg-red-100 text-red-700 border-red-300',
    expirado: 'bg-gray-100 text-gray-500 border-gray-200',
    default: 'bg-gray-100 text-gray-700 border-gray-200'
  };

  const currentVariant = variants[variant?.toLowerCase()] || variants.default;

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${currentVariant}`}>
      {children}
    </span>
  );
};

export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  const baseStyle = "inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-brand-dark text-white hover:bg-brand-primary focus:ring-brand-dark",
    accent: "bg-brand-accent text-brand-dark hover:bg-[#a3d100] focus:ring-brand-accent",
    outline: "border-2 border-brand-dark text-brand-dark hover:bg-brand-light focus:ring-brand-dark",
    ghost: "text-brand-text hover:bg-brand-light hover:text-brand-dark focus:ring-brand-light"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const Card = ({ children, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden ${className}`}>
      {children}
    </div>
  );
};

export const Input = ({ label, id, error, className = '', ...props }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-brand-text mb-1">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-primary/50 transition-colors
          ${error ? 'border-brand-alert' : 'border-gray-300'}
          bg-white text-brand-dark`}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-brand-alert">{error}</p>}
    </div>
  );
};

export const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-brand-dark/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg flex flex-col max-h-[95vh] animate-in fade-in zoom-in-95 duration-200">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-100 flex justify-between items-center shrink-0">
          <h3 className="text-lg font-semibold text-brand-dark truncate pr-2">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-brand-alert transition-colors p-1" type="button">
            <SafeIcon icon={FiIcons.FiX} className="text-xl" />
          </button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};